import React, { useState } from "react";
import { Select } from "antd";
import NumberFormat from "react-number-format";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";

const renderRange = (start, end) => {
  let items = [];
  if (start < end)
    for (let i = start; i <= end; i++) {
      items.push(<Select.Option key={i} value={i}>
        {i}
      </Select.Option>);
    }
  else
    for (let i = start; i >= end; i--) {
      items.push(<Select.Option key={i} value={i}>
        {i}
      </Select.Option>);
    }
  return items;
};

/**
 * Fields for asset assignment and revocation in drawer footer
 * This is an array components
 * @returns
 */
const FringeBenefitDrawerFields = ({ editable, setEditable, setModifiedFields, modifiedFields, setDisableSaveButton, disabledFields= false }) => {
  const [state, setState] = useState(editable.fringeBenefits || {
    depreciationFiscalValue: 600,
    depreciationDeductibleValue: 600,
    totalDeductibleCosts:600,
    rows: [{
      year: 2022,
      amount: 10000,
      totalCosts: 8000
    }]
  });

  /**
     * Add a new row to the component in a specific position
     * @param {} index where add the new row
     */
  const addRow = (index) => {
    let newState = {...state};
    newState.rows.splice(
      index + 1, 0, {
        year: undefined,
        amount: 0,
        totalCosts: 0
      }
    );
    setState(newState);
  };

  /**
     * Remove one of the rows of the component
     * @param {*} index of the row to remove
     */
  const removeRow = (index) => {
    let newState = {...state};
    newState.rows.splice(index, 1);
    setState(newState);
    patchData(newState);
  };

  /**
     * Autosave the data in the component anytime the user change something in the select
     * or remove the focus from the datepicker
     * @param {*} newState
     */
  const patchData = (newState = null) => {
    const sendState = newState ? newState : state;
    let checkValidData = true;

    if (checkValidData) {
      let newModifiedFields = { ...modifiedFields };
      newModifiedFields["fringeBenefits"] = sendState;
      newModifiedFields["autosaveEnabled"] = true;
      let newEditableFields = { ...editable };
      newEditableFields["fringeBenefits"] = sendState;
      setModifiedFields(newModifiedFields);
      setEditable(newEditableFields);
      
      setDisableSaveButton(false);
    } else {      
      setDisableSaveButton(true);
    }
  };

  /**
     * Render dinamically the component depending on the number of rows
     * @returns
     */
  const renderContent = () => {
    let objects = [];
    for (let i = 0; i < state.rows.length; i++) {
      const field = state.rows[i];
      objects.push(<div className="pre-cog-assets-drawer-section" key={i}>
        <div style={{ width: "22%" }}>
          {<div className="precog-withholding-drawer-form—label-text">Anno</div>}
          <Select
            className="pre-cog-assets-drawer-select"
            style={{width: "100%"}}
            getPopupContainer={trigger => trigger.parentNode}
            value={field.year}
            disabled={disabledFields}
            filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onSelect={value => {
              setState(prev => {
                let newState = {...prev};
                newState.rows[i].year = value;
                patchData(newState);
                return newState;
              });
            }}>
            {renderRange(moment().subtract(10, "years").format("YYYY"), moment().format("YYYY"))}
          </Select>
        </div>

        {<div style={{ width: "23%" }}>
          <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center" }}>
            Valore
          </div>
          <NumberFormat
            className="inputCustom drawer-inputCustom pre-cog-assets-drawer-revaluation-field"
            displayType={"input"}
            thousandSeparator={"."}
            decimalSeparator={","}
            suffix={"€"}            
            value={field.amount ? numeral(field.amount).format("0,0.00") : null}
            disabled={disabledFields}
            onValueChange={(values) => {
              setState(prev => {
                let newState = {...prev};
                newState.rows[i].amount = values.floatValue;
                patchData(newState);
                return newState;
              });
            }}
          />
        </div>}

        {<div style={{ width: "23%" }}>
          <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center" }}>
            Totale Costi
          </div>
          <NumberFormat
            className="inputCustom drawer-inputCustom pre-cog-assets-drawer-revaluation-field"
            displayType={"input"}
            thousandSeparator={"."}
            decimalSeparator={","}
            suffix={"€"}
            value={field.totalCosts}
            disabled={disabledFields}
            onValueChange={(values, sourceInfo) => {
              setState(prev => {
                let newState = {...prev};
                newState.rows[i].totalCosts = values.floatValue;
                patchData(newState);
                return newState;
              });
            }}
          />
        </div>}
        {!disabledFields && <div className="precog-withholding-drawer-form—icons" style={{alignItems: "flex-start", marginTop: "44px"}}>
          <FontAwesomeIcon
            icon={["far", "trash-alt"]}
            className={"precog-withholding-drawer-form—icon" + (state.rows.length <= 1 ? " precog-withholding-drawer-form—icon-disabled" : "")}
            style={{ color: "rgb(216, 40, 41)" }}
            onClick={() => {
              removeRow(i);
            }}
          />
          <FontAwesomeIcon
            icon={["fas", "plus-circle"]}
            className={"precog-withholding-drawer-form—icon"}
            style={{ color: "rgb(0, 144, 209)" }}
            onClick={() => {
              addRow(i);
            }}
          />
        </div>}
      </div>);
    }
    return objects;
  };

  return (
    <div data-testid="FringeBenefitDrawerFields" style={{gap: "20px", display: "flex", flexDirection: "column"}}>
      <div className="pre-cog-assets-drawer-titles" style={{padding: 0}}>
        Fringe Benefit*
      </div>
      {renderContent()}
      <div className="pre-cog-assets-drawer-section">
        <div style={{ width: "22%" }}>
          <div style={{marginTop: "24px"}} className="pre-cog-assets-drawer-conto-amount"> {numeral(Math.abs(state.depreciationFiscalValue)).format("0,0.00")} € </div>
          <div className="pre-cog-assets-drawer-subtitles">Valore ammortamento ai fini fiscali</div>
        </div>

        {<div style={{ width: "23%" }}>
          <div style={{marginTop: "24px"}} className="pre-cog-assets-drawer-conto-amount"> {numeral(Math.abs(state.depreciationDeductibleValue)).format("0,0.00")} € </div>
          <div className="pre-cog-assets-drawer-subtitles">Valore ammortamento deducibile</div>
        </div>}

        {<div style={{ width: "23%" }}>
          <div style={{marginTop: "24px"}} className="pre-cog-assets-drawer-conto-amount"> {numeral(Math.abs(state.totalDeductibleCosts)).format("0,0.00")} € </div>
          <div className="pre-cog-assets-drawer-subtitles">Totale costi deducibili</div>
        </div>}
      </div>
    </div>

  );
};

export default FringeBenefitDrawerFields;
